import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import "./WhoThisProgramIsFor.css";
import { IoIosArrowDown } from "react-icons/io";
import { Container } from 'react-bootstrap';

const WhoThisProgramIsFor = ({ data = [] }) => {

  const { t } = useTranslation();

  const [selectedImage, setSelectedImage] = useState(0);

  const [arrowStyle, setArrowStyle] = useState({});

  const containerRef = useRef(null);


  const handleImageClick = (index) => {
    setSelectedImage(index);
  };
  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      const selectedImg = container.querySelectorAll("img")[selectedImage];
      if (selectedImg) {
        const imgRect = selectedImg.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();

        const arrowWidth = 35; // same as your CSS icon size
        const arrowCenter =
          imgRect.left - containerRect.left + imgRect.width / 2 - arrowWidth / 2;

        setArrowStyle({
          left: `${arrowCenter}px`,
        });
      }
    }
  }, [selectedImage]);


  return (
    <section className='WhoThisProgramIsFor'>
      <h5>{t("who_this_program_is_for")}</h5>

      <Container>
        <div
          className='d-flex align-items-center justify-content-around py-4 flex-wrap img-cursoer position-relative'
          ref={containerRef}
        >
          {data?.map((feature, index) => (
            <img
              key={index}
              src={feature.img}
              alt={feature.title}
              className={selectedImage === index ? "imageGreenColor" : "imageBlackColor"}
              onClick={() => handleImageClick(index)}
              style={{ cursor: "pointer" ,width:"80px",height:"80px"}}
            />
          ))}

          {/* 👇 Arrow element */}
          <IoIosArrowDown className="icon-arrow" style={arrowStyle} />
        </div>

        <div>
          {data[selectedImage] && (
            <div className=" py-3 wtp-content">
              <h6 className="p-text fw-bold mb-3">
                {data[selectedImage].title}
              </h6>
              <p>{data[selectedImage].desc}</p>
            </div>
          )}
        </div>
      </Container>
    </section>
  );
};

export default WhoThisProgramIsFor;
